import { executeRequest, Request } from '@jfs/network'
import { getNetworkResponseError, isStatusOK } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApi } from './sendEvent'

const responseParser = (data: any, tokens, request) => {
  if (isStatusOK(data)) {
    sendEventApi(tokens, request, { status: 'SUCCESS' })
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const addAgentUserIdentity = (tokens: any, req: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.addAgentUserIdentity,
    method: 'POST',
    config: apiConfig(tokens),
    body: req,
  }
  sendEventApi(tokens, request, { status: 'INITIATED' })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data, tokens, request)
    })
    .catch((err) => {
      sendEventApi(tokens, request, { status: 'FAILED', errorDescription: err?.data })
      throw getNetworkResponseError(err?.data)
    })
}

export const getaddAgentRequest = (agentUserId: string, aadhaarNo: string) => {
  return {
    agentUserId,
    identity: {
      type: 1, //fixed 1 for aadhaar
      value: aadhaarNo,
    },
  }
}
